(() => {
  const qs = (s, el = document) => el.querySelector(s);

  function buildSidePanel(root) {
    if (!root || root.dataset.daBuilt === "1") return;

    const popular = (() => {
      try { return JSON.parse(root.getAttribute("data-da-popular") || "[]"); }
      catch { return []; }
    })();

    // Shopify inserts its results wrapper inside this element
    const wrapper = qs(".predictive-search__results-groups-wrapper", root);
    if (!wrapper) return;

    // Wrap existing content into "main" pane
    const main = document.createElement("div");
    main.className = "da-ps__main";

    // Move wrapper children into main
    const existing = document.createElement("div");
    while (wrapper.firstChild) existing.appendChild(wrapper.firstChild);
    main.appendChild(existing);

    // Build side pane
    const side = document.createElement("aside");
    side.className = "da-ps__side";
    side.innerHTML = `
      <p class="da-ps__h">Popular searches</p>
      <ul class="da-ps__popular">
        ${popular.slice(0, 10).map((term) => {
          const q = encodeURIComponent(term);
          return `
            <li>
              <a href="/search?q=${q}&options%5Bprefix%5D=last">
                <span>${escapeHtml(term)}</span>
                <span class="da-ps__tag">Search</span>
              </a>
            </li>
          `;
        }).join("")}
      </ul>
    `;

    const grid = document.createElement("div");
    grid.className = "da-ps__grid";
    grid.appendChild(side);
    grid.appendChild(main);

    wrapper.appendChild(grid);
    root.dataset.daBuilt = "1";
  }

  function escapeHtml(str) {
    return String(str)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  // Build whenever predictive search renders/updates
  const observer = new MutationObserver(() => {
    document.querySelectorAll(".predictive-search--header.da-ps").forEach(buildSidePanel);
  });

  window.addEventListener("DOMContentLoaded", () => {
    observer.observe(document.documentElement, { childList: true, subtree: true });
    document.querySelectorAll(".predictive-search--header.da-ps").forEach(buildSidePanel);
  });
})();